import { c as _c } from "react/compiler-runtime";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { useContext, useEffect } from "react";
import { commonApiPostWithoutBodyAndResponse } from "@/services/api/common-api";
interface UseWaveDropsNotificationReadParams {
  readonly waveId: string;
  readonly enabled?: boolean | undefined;
  readonly removeWaveDeliveredNotifications: (waveId: string) => Promise<unknown> | void;
}
export const useWaveDropsNotificationRead = t0 => {
  const $ = _c(6);
  const {
    waveId,
    enabled: t1,
    removeWaveDeliveredNotifications
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const {
    invalidateNotifications
  } = useContext(ReactQueryWrapperContext);
  let t2;
  let t3;
  if ($[0] !== enabled || $[1] !== invalidateNotifications || $[2] !== removeWaveDeliveredNotifications || $[3] !== waveId) {
    t2 = () => {
      if (!enabled) {
        return;
      }
      const syncReadState = async () => {
        if (document.visibilityState !== "visible") {
          return;
        }
        ;
        try {
          await Promise.resolve(removeWaveDeliveredNotifications(waveId));
        } catch (t4) {
          const error = t4;
          console.error("Failed to remove wave delivered notifications:", error);
        }
        commonApiPostWithoutBodyAndResponse({
          endpoint: `notifications/wave/${waveId}/read`
        }).then(() => {
          invalidateNotifications();
        }).catch(_temp);
      };
      const syncReadStateWhenVisible = () => {
        if (document.visibilityState === "visible") {
          syncReadState();
        }
      };
      syncReadState();
      document.addEventListener("visibilitychange", syncReadStateWhenVisible);
      return () => document.removeEventListener("visibilitychange", syncReadStateWhenVisible);
    };
    t3 = [enabled, waveId, removeWaveDeliveredNotifications, invalidateNotifications];
    $[0] = enabled;
    $[1] = invalidateNotifications;
    $[2] = removeWaveDeliveredNotifications;
    $[3] = waveId;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
};
function _temp(error_0) {
  return console.error("Failed to mark feed as read:", error_0);
}